import DateInput from "components/Elements/DateInput/DateInput.js";
import React, { useState, useEffect, useRef } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import { useCustomController } from "../../../../Reusable/Form/useCustomController.js";

const CustomDatepickField = (props) => {
  const { getTextByKey, getDirection } = useContent();
  const { fieldControls } = useCustomController(props);

  useEffect(() => {
    dispayDate();
  }, []);

  const dispayDate = (date) => {
    let newDate = new Date();
    if (date) {
      newDate = new Date(date);
    }
    let month =
      newDate.getMonth() + 1 > 9
        ? newDate.getMonth() + 1
        : `0${newDate.getMonth() + 1}`;
    const day =
      newDate.getDate() > 9 ? newDate.getDate() : `0${newDate.getDate()}`;
    const year = newDate.getFullYear();
    const displayDate = day + "." + month + "." + year;
    return displayDate;
  };

  const handleChange = (e) => {
    fieldControls.onChange(e);
  };
  function convertDate(date) {
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();
    var mmChars = mm.split("");
    var ddChars = dd.split("");
    return (
      yyyy +
      "-" +
      (mmChars[1] ? mm : "0" + mmChars[0]) +
      "-" +
      (ddChars[1] ? dd : "0" + ddChars[0])
    );
  }

  return (
    <div className="dateinput-container">
      <div className="label-field">
        {getTextByKey("profileuserdetails-birthdate")}
      </div>
      <div className="dateinput-div">
        <div className="dateinput-display">
          <div className="display-date">
            {fieldControls.value
              ? dispayDate(fieldControls.value)
              : getTextByKey("profileuserdetails-birthdate")}
          </div>
          <div className="image-date" >
            <Icon name="calendar" />
          </div>
        </div>

        <input
          value={
            fieldControls.value
              ? convertDate(new Date(fieldControls.value))
              : ""
          }
          type="date"
          onChange={(e) => handleChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default CustomDatepickField;
